import firebase from 'firebase/app';
import 'firebase/auth';

import { API_ROOT } from '../../../config/config';

export const LOGIN_USER_PENDING = 'LOGIN_USER_PENDING';
export const LOGIN_USER_FULFILLED = 'LOGIN_USER_FULFILLED';
export const LOGIN_USER_REJECTED = 'LOGIN_USER_REJECTED';

export const LOGOUT_USER_PENDING = 'LOGOUT_USER_PENDING';
export const LOGOUT_USER_FULFILLED = 'LOGOUT_USER_FULFILLED';
export const LOGOUT_USER_REJECTED = 'LOGOUT_USER_REJECTED';

export const CHECK_SSO_PENDING = 'CHECK_SSO_PENDING';
export const CHECK_SSO_FULFILLED = 'CHECK_SSO_FULFILLED';
export const CHECK_SSO_REJECTED = 'CHECK_SSO_REJECTED';

import Cookies from 'universal-cookie';
const cookies = new Cookies();
import axios from 'axios';

//ACTION GENERATIONS

/*
    Logs the user in using Firebase Auth SDK
    @parameters:
    - email: the user's email address.
    - password: the user's password
*/
const loginAction = (email, password) => (dispatch) => {
    dispatch({
        type: LOGIN_USER_PENDING
    });

    return firebase.auth().signInWithEmailAndPassword(email, password).then((user) => {
        locateUserDetailsWithEmail(email).then((companyData) => {
            dispatch({
                type: LOGIN_USER_FULFILLED,
                payload: {
                    user: user,
                    companyID: companyData.companyID,
                    companyName: companyData.companyName,
                    userEmail: email
                }
            });
        }).catch((error) => {
            dispatch({
                type: LOGIN_USER_REJECTED,
                payload: error,
            });
        });
    }).catch(error => {
        dispatch({
            type: LOGIN_USER_REJECTED,
            payload: error,
        });
    });
};

const loginWithToken = (token) => (dispatch) => {
    dispatch({
        type: LOGIN_USER_PENDING
    });

    return firebase.auth().signInWithCustomToken(token).then((user) => {
        locateUserDetailsWithEmail(user.user.uid).then((companyData) => {
            dispatch({
                type: LOGIN_USER_FULFILLED,
                payload: {
                    user: user,
                    companyID: companyData.companyID,
                    companyName: companyData.companyName,
                    userEmail: user.user.uid
                }
            });
        }).catch(() => {
            setUpNewLogin(user.user.uid).then((companyData) => {
                dispatch({
                    type: LOGIN_USER_FULFILLED,
                    payload: {
                        user: user,
                        companyID: companyData.companyID,
                        companyName: companyData.companyName,
                        userEmail: user.user.uid
                    }
                });

            }).catch((error) => {
                cookies.remove('authToken');
                dispatch({
                    type: LOGIN_USER_REJECTED,
                    payload: error,
                });
            });
        });
    }).catch((error) => {
        cookies.remove('authToken');
        dispatch({
            type: LOGIN_USER_REJECTED,
            payload: error,
        });
    });
};

const locateUserDetailsWithEmail = (userEmail) => {
    return new Promise((resolve, reject) => {
        var ref = firebase.database().ref('accounts');
        ref.orderByChild('email').equalTo(userEmail).once('value', snapshot => {
            let userData = snapshot.val();
            if(userData != null && userData != undefined){
                let keys = Object.keys(userData);
                let data = userData[keys[0]];
                if(data.companyID != null && data.companyID != undefined && data.companyName != null && data.companyName != undefined){
                    resolve({companyID: data.companyID, companyName: data.companyName});
                } else {
                    reject('No user exists');
                }
            } else {
                reject('No user exists');
            }
        }).catch((error) => {
            reject(error);
        });
    });    
};

const setUpNewLogin = (userEmail) => {
    return new Promise((resolve, reject) => {
        findCompanyFromEmail(userEmail).then((companyData) => {
            var newPostKey = firebase.database().ref().child('accounts').push().key;
            var updates = {};
            updates['/accounts/' + newPostKey] = {
                'email': userEmail,
                'companyName': companyData.companyName,
                'companyID': companyData.companyID
            };
            firebase.database().ref().update(updates);
            resolve({companyID: companyData.companyID, companyName: companyData.companyName});
        }).catch((error) => {
            reject(error);
        });
    });
};

/* 
    Logs the user out using the Firebase Auth SDK.
*/ 
const logoutAction = () => (dispatch) => {
    dispatch({
        type: LOGOUT_USER_PENDING
    });

    return firebase.auth().signOut().then(() => {
        cookies.remove('authToken');
        dispatch({
            type: LOGOUT_USER_FULFILLED,
        });
    }).catch(error => {
        dispatch({
            type: LOGOUT_USER_REJECTED,
            payload: error,
        });
    });
};

const checkForSSO = (email) => (dispatch) => {
    dispatch({
        type: CHECK_SSO_PENDING
    });

    if (API_ROOT == 'http://localhost:5000/api') {
        dispatch({
            type: CHECK_SSO_FULFILLED,
            payload: false
        });
    } else {
        axios
            .get(API_ROOT + '/requiresSSO?email=' + email)
            .then(res => {
                const shouldUseSSO = res.data;
                dispatch({
                    type: CHECK_SSO_FULFILLED,
                    payload: shouldUseSSO
                });
            })
            .catch(error => {
                console.log(error);
                dispatch({
                    type: CHECK_SSO_REJECTED,
                    payload: false
                });
            });
    }
    
   
};

const findCompanyFromEmail = (userEmail) => {
    return new Promise((resolve, reject) => {
        let emailExtension = userEmail.split('@').pop();
        var companyName = '';
        var companyIDString = '';
        firebase.database().ref('/companies/').once('value').then(snapshot => {
            let companiesData = snapshot.val();
            for(var companyID in companiesData) {
                let companyData = companiesData[companyID];
                if(companyData.emailExtensions != undefined && companyData.emailExtensions != null) {
                    for(var email in companyData.emailExtensions){
                        if (companyData.emailExtensions[email] == emailExtension){
                            companyName = companyData.name;
                            companyIDString = companyID;
                            
                            break;
                        }
                    }
                } 
            }
            if(companyName != '' && companyIDString != ''){
                resolve({
                    companyName: companyName,
                    companyID: companyIDString
                });
            } else {
                reject('No company associated with this email address');
            }
        }).catch((error) => {
            reject(error);
        });
    });
};

export {loginAction as login, logoutAction as logout, loginWithToken, checkForSSO};


// WEBPACK FOOTER //
// ./src/components/state/actions/UserActions.js